<template>
    <section class="userSteps">
       <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row align-items-center" v-show="documentStatus == 'PENDING' && !startSubSub">
            <div class="col-12 d-flex align-items-center justify-content-between mb-4">
                <router-link class="d-flex align-items-center backBtn medium" :to="{name : 'create_broker_account6',params:{'id':$route.params.id}}">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('mannual_proof.text1')}}
                </router-link>
                <div class="counterStep text-end">
                    <p>{{$t('mannual_proof.text2')}}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{$t('mannual_proof.text3')}} <span class="bgTitle">{{$t('mannual_proof.text4')}}</span></h3>
                </div>
            </div>
            <div class="col-12 col-md-10">
                <h4 class="mb-2 f-20">{{$t('subsum.text1')}}</h4>
                <p>{{$t('subsum.text2')}}</p>
            </div>
            <div class="col-12">
                <h4 class="mb-2 f-20">{{$t('subsum.text3')}}</h4>
                <ul class="dotList">
                    <li>{{$t('subsum.text4')}}</li>
                    <li>{{$t('subsum.text5')}}</li>
                    <li>{{$t('subsum.text6')}}</li>
                </ul>
            </div>
            <div class="col-12 mb-3">
                <h4 class="mb-2 f-20">{{$t('subsum.text7')}}</h4>
                <ul class="dotList">
                    <li>{{$t('subsum.text8')}}</li>
                    <li>{{$t('subsum.text9')}}</li>
                    <li>{{$t('subsum.text10')}}</li>
                    <li>{{$t('subsum.text11')}}</li>
                </ul>
            </div>
            <div class="col-12 mb-3">
                <div class="customAlert position-relative f-13">
                    <i class="alertCircle fa fa-exclamation" aria-hidden="true"></i>
                    <h6 class="mt-2">{{$t('subsum.text12')}}</h6>
                    <p>{{$t('subsum.text13')}}</p>
                    <p>{{$t('subsum.text14')}}</p>
                    </div>
            </div>
            <div class="col-6 mt-4">
                <a href="javascript:void(0)" class="grd_btn full_size" @click="getSumSubDetail()"> {{$t('subsum.text15')}}
                </a>
            </div>
        </div>
        <div class="publicProfile row align-items-center" v-show="documentStatus == 'PENDING' && startSubSub">
            <!-- <div class="col-12 d-flex align-items-center justify-content-between mb-4">
                <router-link class="d-flex align-items-center backBtn medium" :to="{name : 'create_broker_account5',params:{'id':this.$route.params.id}}">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> Back
                </router-link>
                <div class="counterStep text-end">
                    <p>2 out of 3</p>
                </div>
            </div> -->
            <div  id="sumsub-websdk-container"></div>
        </div>
        <mannualUpload v-if="documentStatus == 'MANUAL_UPLOAD'" />
        <div v-if="documentStatus == 'UNDER_REVIEW'">
            <div class="publicProfile row vh-custom align-items-center justify-content-center">
                 <div class="col-12 col-md-10">
                    <div class="border text-center p-md-4 p-2 br-10">
                        <img  :src="`${static_vars.imagePath}/assets/images/updatedSoon.gif`" :alt="$t('subsum.text22')" :title="$t('subsum.text22')" />
                        <h5 class="medium my-4 line-4"><span class="primary semibold">{{$t('subsum.text16')}}</span>,{{$t('subsum.text17')}}<br>{{$t('subsum.text18')}}</h5>
                        <a :href="`${static_vars.domainURL}dashboard`" class="grd_btn">{{$t('subsum.text19')}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
         <div v-if="documentStatus == 'OPEN-TICKET'">
            <div class="publicProfile row vh-custom align-items-center">
                <div class="col-12 col-md-8">
                    <div class="border text-center p-md-4 p-2 br-10">
                        <img width="380" :src="`${static_vars.imagePath}/assets/images/additionalInfo.gif`" :alt="$t('subsum.text23')" :title="$t('subsum.text23')" />
                        <h5 class="medium my-4">{{$t('subsum.text20')}}</h5>
                        <a href="javascript:void(0)" class="grd_btn full_size" @click="openTicket()">{{$t('subsum.text21')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
     <!-- Data Featching Loader Here -->

    
     <div class="modal fade giftModal featchData show" v-if="store.singleLoading">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="position-relative d-flex align-items-center justify-content-between overflow-hidden">
                        <div class="featchLogo">
                            <img :src="`${static_vars.imagePath}/assets/images/loaderIcon/fxSmal.png`" alt="ZuluTrade" title="ZuluTrade">
                        </div>
                        <div class="position-absolute loader-line">
                            <img :src="`${static_vars.imagePath}/assets/images/loaderIcon/ltRts.png`" alt="ZuluTrade" title="ZuluTrade">
                        </div>
                        <div class="featchLogo">
                            <img :src="`${static_vars.imagePath}/assets/images/loaderIcon/zulSmal.png`" alt="Fxview" title="Fxview">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useMainStore } from "@/store";
    import snsWebSdk from "@sumsub/websdk";
    import mannualUpload from './mannual-upload'
export default {
    setup() {
        const store = useMainStore();
        return { store };
    },
    data() {
        return {
            startSubSub : false,
            showRejectionBlock : false,
            subsubStatus : '',
            documentStatus  : '',
            ticketLink : ''

        }
    },
    components : {
        mannualUpload
    },
    methods:{
        openTicket(){
            this.store.openBrokerTicket({},true,this.$route.params.id).then((response) =>{
                if(this.ticketLink){
                    let link = this.ticketLink+'?auth='+response
                    window.open(link, '_blank');
                }
            })
        },
    getSumSubDetail(){
        let formData = {
            'email' : this.store.customerDetail.email
        }
        this.store.getSumSubToken(formData,true,this)
    },
    launchWebSdk(accessToken, applicantEmail, applicantPhone) {
        let snsWebSdkInstance = snsWebSdk.init(
                this.store.sumSubDetail.token,
                // token update callback, must return Promise
                // Access token expired
                // get a new one and pass it to the callback to re-initiate the WebSDK
                () => this.getNewAccessToken(this.store.sumSubDetail.token)
            )
            .withConf({
                lang: 'en', //language of WebSDK texts and comments (ISO 639-1 format)
                email: applicantEmail,
                phone: applicantPhone,
                i18n: {}, //JSON of custom SDK Translations
                uiConf: {
                   customCssStr:
                  "button.submit:active:not(:disabled), button.submit:hover:not(:disabled):not(.disabled):not(:active), button[type=submit]:active:not(:disabled), button[type=submit]:hover:not(:disabled):not(.disabled):not(:active), #loader .round-icon, .round-icon{ background: #073763; color: #fff; background-image:none;}button.submit, button[type=submit]{ background: #073763; color: #fff;} .step.active .title, h3, h4, .content .desktop p, .document-status h2{color:#414649} .step.active .bullet:before, .step.active.success .bullet:before, .radio-item .checkmark:after{background-color:#073763} .mobile-button .fa-icon, .accent{color:#073763} .checkbox input:checked~.checkmark{background-color:#073763 ;border-color:#073763} .step.active .line, .step.success .line{background-color:#073763} .document-status p, p, .checkbox, .radio-item{color:#888da8;}",
                },
            })
            .withOptions({ addViewportTag: false, adaptIframeHeight: true})
            // see below what kind of messages WebSDK generates
            .on("idCheck.onApplicantSubmitted", (submitted) => {
                console.log("submitted", submitted);
            })
            .on("idCheck.applicantStatus", (status) => {
                console.log('status',status)
              if (
                status.reviewResult &&
                status.reviewResult.reviewAnswer == "GREEN"
              ) {
                //this.$router.replace({'name':'account_prefrences',params:{'id':this.$route.params.id}})
                this.documentStatus = 'UNDER_REVIEW'
                // this.sumsubVerified = true;
              }
              if (
                status.reviewResult &&
                status.reviewResult.reviewAnswer &&
                status.reviewResult.reviewAnswer == "RED" &&
                status.reviewResult.reviewRejectType &&
                status.reviewResult.reviewRejectType == "FINAL"
              ) {//documents are rejected 
                 // console.log('red')
                //this.showRejectionBlock = true;
                this.startSubSub = false
                this.documentStatus = 'MANUAL_UPLOAD'
              }
            })
            .on('idCheck.stepCompleted', (payload) => {
                console.log('stepCompleted', payload)
            })
            .on('idCheck.onError', (error) => {
                console.log('onError', error)
            })
            .build();

        // you are ready to go:
        // just launch the WebSDK by providing the container element for it
        snsWebSdkInstance.launch('#sumsub-websdk-container')
    },
    getNewAccessToken(accessToken) {
      return Promise.resolve(accessToken)// get a new token from your backend
    },
    intializeSumSub({ accesstoken, levelname }) {
      this.launchWebSdk(
        process.env.VUE_APP_SUMSUB_URL,
        levelname,
        accesstoken,
        this.store.customerDetail.email,
        "",
        ""
      );
    },
  },
  created(){
      this.store.callUserBrokerStatusList({},true,this.$route.params.id).then(() => {
        if(Object.keys(this.store.brokerStatusList).length){
                if('currentStep' in this.store.brokerStatusList && parseInt(this.store.brokerStatusList.currentStep) == 6){
                    let stepInfo = this.store.brokerStatusList.stepsStatus ? this.store.brokerStatusList.stepsStatus[parseInt(this.store.brokerStatusList.currentStep)-1] : {}
                    if(stepInfo.openTicket){
                        this.documentStatus = 'OPEN-TICKET'
                        this.ticketLink = stepInfo.ticketUrl
                    }else if((stepInfo.identityStatus.status == 'REJECTED' && stepInfo.identityStatus.toUploadFrom == 'SUMSUB') || (stepInfo.selfieStatus.status == 'REJECTED' && stepInfo.selfieStatus.toUploadFrom == 'SUMSUB')){
                        this.documentStatus = 'PENDING'
                    }else if(stepInfo.identityStatus.status == 'UPLOADED' || stepInfo.selfieStatus.status == 'UPLOADED'){
                        this.documentStatus = 'UNDER_REVIEW'
                    }else if(stepInfo.identityStatus.status == 'PENDING' || stepInfo.selfieStatus.status == 'PENDING'){
                        this.documentStatus = 'PENDING'
                    }else if((stepInfo.identityStatus.status == 'REJECTED' && stepInfo.identityStatus.toUploadFrom == 'MANUAL') || (stepInfo.selfieStatus.status == 'REJECTED' && stepInfo.selfieStatus.toUploadFrom == 'MANUAL')){
                        this.documentStatus = 'MANUAL_UPLOAD'
                    }else{
                        this.documentStatus = 'PENDING'
                    }
                }else{
                     this.documentStatus = 'PENDING'
                }

                this.store.$patch({'linkBrokerID' : null})
                if(!this.store.brokerStatusList.completed){
                    if(this.store.brokerSettingsList.REGISTRATION_STEPS_MOBILE && this.store.brokerSettingsList.REGISTRATION_STEPS_MOBILE.length && ('currentStep' in this.store.brokerStatusList)){
                        let step = parseInt(this.store.brokerStatusList.currentStep) == 0 ? 0 : parseInt(this.store.brokerStatusList.currentStep)-1
                        if(parseInt(this.store.brokerStatusList.currentStep) == 6){
                            if (this.store.brokerStatusList.stepsStatus[step - 1].porStatus.status == 'REJECTED') {
                                this.$router.replace({path : '/upload-por'+'/'+this.$route.params.id})
                            }else{
                                this.$router.replace({path : '/sumsub'+'/'+this.$route.params.id})
                            }
                        }else{
                            this.$router.replace({path :this.store.StepsJson[this.store.brokerSettingsList.REGISTRATION_STEPS_MOBILE[step]]+'/'+this.$route.params.id})
                        }
                    }
                }else{
                    if(this.store.userAccoutDetail.requiredActions && this.store.userAccoutDetail.requiredActions.length){
                        this.$router.replace({path : '/sutaibility'})
                    }else{
                        let path = `${this.static_vars.domainURL}dashboard`
                        window.location.replace(path)
                    }
                }
            }
        })
    }
}
</script>